import { useState, useEffect, useRef } from "react";

const WORD_A = "UNREAL".split("");
const WORD_B = "ACADEMY".split("");

export const IntroSplash = () => {
  const [stage, setStage] = useState("intro");
  const [pos, setPos] = useState(null);
  const [flyTo, setFlyTo] = useState(null);
  const posRef = useRef(null);
  const flyTimer = useRef(null);

  useEffect(() => {
    if (stage === "done") return;
    document.body.classList.add("intro-active");
    const measure = () => {
      const b = document.querySelector("nav.forge-nav .logo")?.getBoundingClientRect();
      if (!b) return;
      const scale = Math.min(3.1, (window.innerWidth * 0.88) / b.width);
      const p = { left: b.left, top: b.top,
        dx: window.innerWidth / 2 - (b.left + b.width / 2),
        dy: window.innerHeight / 2 - (b.top + b.height / 2), scale };
      posRef.current = p;
      setPos(p);
    };
    measure();
    if (document.fonts?.ready) document.fonts.ready.then(measure);
    const t = setTimeout(fly, 2900);
    return () => { clearTimeout(t); clearTimeout(flyTimer.current); document.body.classList.remove("intro-active"); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fly = () => {
    const p = posRef.current;
    const b = document.querySelector("nav.forge-nav .logo")?.getBoundingClientRect();
    if (p && b) setFlyTo({ x: b.left - p.left, y: b.top - p.top });
    setStage((s) => (s === "intro" ? "fly" : s));
    flyTimer.current = setTimeout(() => {
      document.body.classList.remove("intro-active");
      setStage("done");
    }, 1050);
  };

  if (stage === "done" || !pos) return null;

  return (
    <div className={`intro-overlay ${stage === "fly" ? "out" : ""}`} onClick={fly} data-testid="intro-splash">
      <div className="intro-grid" />
      <div className="intro-glow" />
      {[...Array(26)].map((_, i) => (
        <span key={i} className="intro-spark"
          style={{ left: `${(i * 137 + 19) % 100}%`, animationDuration: `${2.2 + (i % 5) * 0.55}s`,
            animationDelay: `${(i % 9) * 0.3}s`, background: i % 3 ? "#38b6ff" : "#8fe6ff" }} />
      ))}
      <div className="logo intro-logo" data-testid="intro-logo"
        style={{ left: pos.left, top: pos.top,
          transform: stage === "fly"
            ? (flyTo ? `translate(${flyTo.x}px, ${flyTo.y}px)` : "none")
            : `translate(${pos.dx}px, ${pos.dy}px) scale(${pos.scale})`,
          transformOrigin: "center", transition: stage === "fly" ? "transform .95s cubic-bezier(.65,0,.22,1)" : "none" }}>
        <div className="cube intro-cube"></div>
        <span>{WORD_A.map((c, i) => <span key={i} className="intro-letter" style={{ animationDelay: `${0.4 + i * 0.07}s` }}>{c}</span>)}</span>
        <em>{WORD_B.map((c, i) => <span key={i} className="intro-letter" style={{ animationDelay: `${0.85 + i * 0.07}s` }}>{c}</span>)}</em>
      </div>
      {stage === "intro" && (
        <>
          <div className="intro-scan" />
          <p className="intro-tag">MASTER THE ENGINE · BUILD YOUR WORLDS</p>
          <p className="intro-skip">CLICK TO SKIP</p>
        </>
      )}
    </div>
  );
};
